import { render, staticRenderFns } from "./BlogShares.vue?vue&type=template&id=99de2bc4&"
import script from "./BlogShares.vue?vue&type=script&lang=js&"
export * from "./BlogShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports